import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './NavigationBar.css';
import React, { useState, useCallback } from 'react';
import TopNavigation from './TopNavigation';
import { get } from '../../utils/getPropertyByPath';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import MainNavigation from './MainNavigation';
import Breadcrumbs from './Breadcrumbs';
import LoginRegisterPopup from './LoginRegisterPopup';
import VenueShortlist from '../VenueShortlist/VenueShortlist';
import { NAV_LINKS, isNavLinkRendered } from '../../utils/index';
import useProfile from '../../utils/hooks/useProfile';

/** Defines the props that are populated by data from CMS */

/** Defines the props that are populated by data from CMS and application usage */
// We can omit certain properties from some types because those properties are defined
// by the NavigationBar - the properties are not received from parent components.

var commonStyles = "c1ioqwx1";
var transparentNavStyles = "t1nu2ebk";
var ltrStyles = "l1jmuzcy";
var rtlStyles = "rngo141";
var NavigationBar = function NavigationBar(_ref) {
  var topNav = _ref.topNav,
    mainNav = _ref.mainNav,
    dictionary = _ref.dictionary,
    accessibilitySettings = _ref.accessibilitySettings,
    languageSelector = _ref.languageSelector,
    login = _ref.login,
    activeLanguage = _ref.activeLanguage,
    breadcrumb = _ref.breadcrumb,
    search = _ref.search,
    analytics = _ref.analytics,
    breadcrumbAnalytics = _ref.breadcrumbAnalytics,
    searchAnalytics = _ref.searchAnalytics,
    _ref$transparentNavig = _ref.transparentNavigation,
    transparentNavigation = _ref$transparentNavig === void 0 ? false : _ref$transparentNavig;
  var _useState = useState({
      loginVisible: false,
      languageSelectorVisible: false,
      accessibilitySettingsVisible: false,
      searchVisible: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var setHTMLScroll = React.useCallback(function (_ref2) {
    var disabled = _ref2.disabled;
    if (typeof window === undefined) return;
    var html = document.querySelector('html');
    if (html) html.style.overflow = disabled ? 'hidden' : '';
  }, []);
  var toggleLanguageSelectorVisibility = useCallback(function () {
    var newState = {
      languageSelectorVisible: !state.languageSelectorVisible,
      accessibilitySettingsVisible: false,
      searchVisible: false,
      loginVisible: !state.loginVisible
    };
    setHTMLScroll({
      disabled: newState.languageSelectorVisible
    });
    if (!state.languageSelectorComponent) {
      import(/* webpackChunkName: "LanguageSelector" */'./LanguageSelector').then(function (component) {
        newState.languageSelectorComponent = component.default;
        setState(newState);
      });
    } else {
      setState(newState);
    }
  }, [state.languageSelectorVisible, state.languageSelectorComponent, setHTMLScroll]);
  var toggleLoginVisibility = useCallback(function () {
    var newState = {
      languageSelectorVisible: false,
      accessibilitySettingsVisible: false,
      searchVisible: false,
      loginVisible: !state.loginVisible
    };
    setHTMLScroll({
      disabled: newState.loginVisible
    });
    if (!state.loginComponent) {
      import(/* webpackChunkName: "Login" */'./Login').then(function (component) {
        newState.loginComponent = component.default;
        setState(newState);
      });
    } else {
      setState(newState);
    }
  }, [state.loginVisible, state.loginComponent, setHTMLScroll]);
  var toggleAccessibilitySettingsVisibility = useCallback(function () {
    var newState = {
      accessibilitySettingsVisible: !state.accessibilitySettingsVisible,
      languageSelectorVisible: false,
      searchVisible: false,
      loginVisible: false
    };
    setHTMLScroll({
      disabled: newState.accessibilitySettingsVisible
    });
    if (!state.accessibilitySettingsComponent) {
      import(/* webpackChunkName: "AccessibilitySettings" */'./AccessibilitySettings').then(function (component) {
        newState.accessibilitySettingsComponent = component.default;
        setState(newState);
      });
    } else {
      setState(newState);
    }
  }, [state.accessibilitySettingsVisible, state.accessibilitySettingsComponent, setHTMLScroll]);
  var toggleSearchVisibility = useCallback(function () {
    var newState = {
      accessibilitySettingsVisible: false,
      languageSelectorVisible: false,
      searchVisible: !state.searchVisible,
      loginVisible: false
    };
    setHTMLScroll({
      disabled: newState.searchVisible
    });
    if (!state.searchComponent) {
      import(/* webpackChunkName: "SearchContainer" */'./SearchContainer').then(function (component) {
        newState.searchComponent = component.default;
        setState(newState);
      });
    } else {
      setState(newState);
    }
  }, [state.searchVisible, state.searchComponent, setHTMLScroll]);
  var topNavActions = {
    onLoginClicked: toggleLoginVisibility,
    onLanguageClicked: toggleLanguageSelectorVisibility,
    onAccessibilitySettingsClicked: toggleAccessibilitySettingsVisibility
  };
  var mainNavActions = {
    onLoginClicked: toggleLoginVisibility,
    onLanguageClicked: toggleLanguageSelectorVisibility,
    onAccessibilitySettingsClicked: toggleAccessibilitySettingsVisibility,
    onSearchClicked: toggleSearchVisibility
  };
  var LanguageSelector = state.languageSelectorComponent;
  var Login = state.loginComponent;
  var AccessibilitySettings = state.accessibilitySettingsComponent;
  var SearchContainer = state.searchComponent;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var userProfile = useProfile();
  var siteName = '';
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    venueShortlistVisible = _React$useState2[0],
    setVenueShortlistVisible = _React$useState2[1];
  var menulinksArray = get(mainNav.menuLinks, 'targetItem.links');
  var venueShortlists = menulinksArray && isNavLinkRendered(menulinksArray, NAV_LINKS['venuesShortlist']);
  var removeVenueFromShortlistAnalytics = mainNav.removeVenueFromShortlistAnalytics,
    shareYourShortlistAnalytics = mainNav.shareYourShortlistAnalytics,
    requestProposalAnalytics = mainNav.requestProposalAnalytics,
    yourShortlistedBottomAnalytics = mainNav.yourShortlistedBottomAnalytics,
    yourShortlistedTopAnalytics = mainNav.yourShortlistedTopAnalytics,
    interactionWithVenueRPFormAnalytics = mainNav.interactionWithVenueRPFormAnalytics;
  return /*#__PURE__*/React.createElement("div", {
    className: "\n        ".concat(commonStyles, "\n        ").concat(rtl ? rtlStyles : ltrStyles, "\n        ").concat(transparentNavigation ? transparentNavStyles : '', "\n        ").concat(siteName, "\n        ").concat(pageEditing ? onPageEditor : '', "\n      ")
  }, /*#__PURE__*/React.createElement(LoginRegisterPopup, {
    dictionary: dictionary,
    accountLinks: mainNav.accountLinks
  }), /*#__PURE__*/React.createElement(LoginRegisterPopup, {
    dictionary: dictionary,
    accountLinks: mainNav.accountLinks,
    videoPopup: true
  }), /*#__PURE__*/React.createElement(TopNavigation, {
    userProfile: userProfile,
    accessibilitySettingsTitle: get(accessibilitySettings, 'targetItem.title.value'),
    globalLinks: topNav.globalLinks,
    actions: topNavActions,
    dictionary: dictionary
    // {...dictionary}
    ,

    accountLinks: mainNav.accountLinks,
    activeLanguageName: activeLanguage.languageName,
    languageSelectorTitle: get(languageSelector, 'targetItem.title.value'),
    analytics: {
      globalLinksAnalytics: analytics.globalLinksAnalytics,
      superNavAnalytics: analytics.superNavAnalytics
    }
  }), /*#__PURE__*/React.createElement(MainNavigation, _extends({}, mainNav, {
    userProfile: userProfile,
    dictionary: dictionary,
    globalLinks: topNav.globalLinks,
    actions: mainNavActions,
    mainMenuAnalytics: analytics.mainMenuAnalytics,
    globalLinksAnalytics: analytics.globalLinksAnalytics,
    governmentLogoAnalytics: analytics.governmentLogoAnalytics,
    removeVenueFromShortlistAnalytics: mainNav.removeVenueFromShortlistAnalytics,
    shareYourShortlistAnalytics: mainNav.shareYourShortlistAnalytics,
    requestProposalAnalytics: mainNav.requestProposalAnalytics,
    yourShortlistedBottomAnalytics: mainNav.yourShortlistedBottomAnalytics,
    yourShortlistedTopAnalytics: mainNav.yourShortlistedTopAnalytics,
    interactionWithVenueRPFormAnalytics: mainNav.interactionWithVenueRPFormAnalytics,
    languageSelector: languageSelector,
    venueShortlistVisible: venueShortlistVisible,
    setVenueShortlistVisible: setVenueShortlistVisible,
    venueShortlists: venueShortlists
  })), /*#__PURE__*/React.createElement(Breadcrumbs, _extends({}, breadcrumb, {
    userProfile: userProfile,
    breadcrumbAnalytics: breadcrumbAnalytics,
    dictionary: dictionary
  })), LanguageSelector ? /*#__PURE__*/React.createElement(LanguageSelector, _extends({}, languageSelector, {
    onLanguageSelectorClosed: toggleLanguageSelectorVisibility,
    visible: state.languageSelectorVisible,
    analytics: analytics.superNavAnalytics
  })) : null, Login ? /*#__PURE__*/React.createElement(Login, _extends({}, login, {
    onLoginClosed: toggleLoginVisibility,
    visible: state.loginVisible,
    analytics: analytics.superNavAnalytics
  })) : null, AccessibilitySettings ? /*#__PURE__*/React.createElement(AccessibilitySettings, _extends({}, accessibilitySettings, {
    onAccessibilitySettingsClosed: toggleAccessibilitySettingsVisibility,
    visible: state.accessibilitySettingsVisible,
    activeLanguageCode: activeLanguage.languageCode,
    analytics: {
      textSizeAnalytics: analytics.textSizeAnalytics,
      contrastSwitchAnalytics: analytics.contrastSwitchAnalytics,
      readSpeakerAnalytics: analytics.readSpeakerAnalytics
    }
  })) : null, SearchContainer ? /*#__PURE__*/React.createElement(SearchContainer, _extends({}, search, {
    onToggleSearch: toggleSearchVisibility,
    visible: state.searchVisible,
    analytics: searchAnalytics
  })) : null, !!venueShortlists && /*#__PURE__*/React.createElement(VenueShortlist, {
    fields: {
      dictionary: dictionary
    },
    params: {},
    isOpen: venueShortlistVisible,
    setOpen: setVenueShortlistVisible,
    analytics: {
      removeVenueFromShortlistAnalytics: removeVenueFromShortlistAnalytics,
      shareYourShortlistAnalytics: shareYourShortlistAnalytics,
      requestProposalAnalytics: requestProposalAnalytics,
      yourShortlistedBottomAnalytics: yourShortlistedBottomAnalytics,
      yourShortlistedTopAnalytics: yourShortlistedTopAnalytics,
      interactionWithVenueRPFormAnalytics: interactionWithVenueRPFormAnalytics
    },
    formIdModifier: 'nav-helper'
  }));
};
var onPageEditor = "o1bot6bu";
export default NavigationBar;